// The opt-in lander carries each standard contact field to the server in a hidden `#cfAR` input
// whose id is `cf_contact_<suffix>` (projects/cloudflare-worker/src/views/lander.html). These are
// the suffixes. `getContactForm` (user_pages lander/submit.ts) only writes a page input into one of
// them when the input is a standard field, and the editor warns when a Custom Type uses one of
// these names, since a custom key equal to a carrier used to overwrite or delete it (ENG-8498).
// Keep in sync with lander.html and Editor::ElementPresets::RESERVED_CUSTOM_INPUT_KEYS.
export const CONTACT_CARRIER_ID_SUFFIXES: readonly string[] = [
  'name',
  'first_name',
  'last_name',
  'email',
  'phone',
  'shipping_id',
  'shipping_address',
  'shipping_address_2',
  'shipping_city',
  'shipping_state',
  'shipping_country',
  'shipping_zip',
  'shipping_set_default_address',
  'billing_same_as_shipping',
  'billing_id',
  'billing_address',
  'billing_address_2',
  'billing_city',
  'billing_state',
  'billing_country',
  'billing_zip',
  'affiliate_id',
  'cf_affiliate_id',
  'affiliate_aff_sub',
  'affiliate_aff_sub2',
  'time_zone',
  'number',
  'month',
  'year',
  'cvc',
]

// Page input names whose carrier suffix differs from the name: the Phone input renders
// `name="phone_number"` but its carrier is `#cf_contact_phone` (`contact[phone_number]`).
export const CONTACT_CARRIER_NAME_ALIASES: ReadonlyMap<string, string> = new Map([['phone_number', 'phone']])

// `country` and `state` land in the shipping carriers: submit.ts renames them to `shipping_country`
// and `shipping_state`. That holds for a Custom Type with exactly these keys too, because
// version115Compat (pageTreeCompat.ts) turned legacy State and Country Inputs into such custom types
// and they have always filled the shipping address.
export const SHIPPING_RENAMED_FIELD_NAMES: ReadonlySet<string> = new Set(['country', 'state'])

// Custom Type keys that would collide with a carrier: every suffix and every alias. `country` and
// `state` are left out on purpose. Those exact keys are meant to fill the shipping address (above),
// and a case variant posts as an ordinary custom attribute, so warning would only push a migrated
// page to rename a key that works.
export const CONTACT_CARRIER_FIELD_NAMES: ReadonlySet<string> = new Set([
  ...CONTACT_CARRIER_ID_SUFFIXES,
  ...CONTACT_CARRIER_NAME_ALIASES.keys(),
])
